import * as React from "react";
import styled from "styled-components";
import Container from "../Container";
import { ContentBlockTitleBlockSubType } from "../../types/Types";
import { fonts } from "../../styles/variables";

const StyledContentBlockTitleBlockSub = styled.div`
  margin: 35px 0;
`;
const Headline = styled.h2`
  font: ${fonts.headline};
  text-align: center;
  margin: 0;
  text-transform: uppercase;
`;

const ContentBlockTitleSubBlock: React.FC<ContentBlockTitleBlockSubType> = ({
  titleBlockTitleSub,
}) => {
  return (
    <StyledContentBlockTitleBlockSub>
      <Container>
        <Headline>{titleBlockTitleSub}</Headline>
      </Container>
    </StyledContentBlockTitleBlockSub>
  );
};
export default ContentBlockTitleSubBlock;
